import { render, staticRenderFns } from "./OpenRouterChannelDetail.vue?vue&type=template&id=e97d2fca&scoped=true"
import script from "./OpenRouterChannelDetail.vue?vue&type=script&lang=js"
export * from "./OpenRouterChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./OpenRouterChannelDetail.vue?vue&type=style&index=0&id=e97d2fca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97d2fca",
  null
  
)

export default component.exports